import styles from './S05.module.css';

import ideaLogo from './images/idea-logo.jpg';
import oxfamLogo from './images/oxfam-logo.jpg';
import edelmanLogo from './images/edelman-logo.jpg';
import acsLogo from './images/acs-logo.png'

export default function S05(){

  return <div className={styles.main}>
    <div className={styles.upper}>
      <h3>Knowledge Partners</h3>
      <div className={styles.cardContainer}>
          <div className={styles.card}>
          <div className={styles.imageContainer}>
            <img src={ideaLogo} alt="IDEA Logo" className={styles.idea}/>
          </div>

            <p>The International Institute for Democracy and Electoral Assistance (International IDEA) is an intergovernmental organization that supports sustainable democracy worldwide.</p>
          </div>
          <div className={styles.card}>
          <div className={styles.imageContainer}>
            <img src={oxfamLogo} alt="Oxfam Logo" />
          </div>
            <p>Oxfam is an international confederation of 21 organizations, working with its partners and allies, reaching out to millions of people around the world. Together, we tackle inequalities to end poverty and injustice, now and in the long term – for an equal future.</p>
          </div>
          <div className={styles.card}>
          <div className={styles.imageContainer}>
            <img src={edelmanLogo} alt="Edelman Logo" />
          </div>
            <p>Edelman is a global communications firm that partners with businesses and organizations to evolve, promote and protect their brands and reputations. For twenty years, through the Edelman Trust Barometer, Edelman has studied trust in four institutions (media, business, NGOs and government) around the world.</p>
          </div>
      </div>
    </div>

    <div className={styles.bottom}>
      <h3>Financial Partner</h3>
      <div className={styles.cardContainer}>
      <div className={styles.card}>
      <div className={styles.imageContainer}>
        <img src={acsLogo} alt="ACS Logo" className={styles.acs}/>
      </div>
        <p>Fundación ACS has been working for 20 years to improve the quality of life of people through different lines of action that address disability, heritage, culture, environment, medical research, engineering and architecture, economics and law, and development cooperation.
</p>
      </div>
      </div>
    </div>

  </div>;
}
